type IntentName = string & { __brand__: 'IntentName' }

export type WebViewIntent = {
  name: IntentName
  payload?: unknown
}

export function createIntent(name: string, payload?: unknown): WebViewIntent {
  return {
    name: name as IntentName,
    payload,
  }
}

/** Use this when the webview button should behave like the web version */
export const INTENT_SAME_AS_WEB = createIntent('SAME_AS_WEB')